import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import { PATH_AFTER_LOGIN } from '../config';
import LoadingScreen from '../components/LoadingScreen';
// import MainLayout from '../layouts/main';

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    { path: '/', element: <Home /> },
    { path: '/admin/login', element: <Login /> },
    { path: 'auth/register', element: <Register /> },
    // Admin Dashboard Routes Start
    {
      path: 'dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <GeneralAnalytics /> },
        { path: 'currency', element: <Currency /> },
        { path: 'addcurrency', element: <AddCurrency /> },
        { path: 'editcurrency/:id', element: <EditCurrency /> },
        { path: 'price', element: <Price /> },
        { path: 'addprice', element: <AddPrice /> },
        { path: 'editprice/:id', element: <EditPrice /> },
        { path: 'organization', element: <Organization /> },
        { path: 'addorganization', element: <AddOrganization /> },
        { path: 'editorganization/:id', element: <EditOrganization /> },
        { path: 'donation', element: <Donation /> },
        { path: 'editadmin', element: <EditAdmin /> },
        {
          path: 'e-commerce',
          children: [{ element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true }],
        },
      ],
    },
    // Admin Dashboard Routes End
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const Home = Loadable(lazy(() => import('../pages/dashboard/Home/Home')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));
const EditAdmin = Loadable(lazy(() => import('../pages/dashboard/EditAdmin/EditAdmin')));
const Donation = Loadable(lazy(() => import('../pages/dashboard/Donation/Donation')));
const Price = Loadable(lazy(() => import('../pages/dashboard/Price/Price')));
const AddPrice = Loadable(lazy(() => import('../pages/dashboard/Price/AddPrice')));
const EditPrice = Loadable(lazy(() => import('../pages/dashboard/Price/EditPrice')));
const Currency = Loadable(lazy(() => import('../pages/dashboard/Currency/Currency')));
const AddCurrency = Loadable(lazy(() => import('../pages/dashboard/Currency/AddCurrency')));
const EditCurrency = Loadable(lazy(() => import('../pages/dashboard/Currency/EditCurrency')));
const Organization = Loadable(lazy(() => import('../pages/dashboard/Organization/Organization')));
const AddOrganization = Loadable(lazy(() => import('../pages/dashboard/Organization/AddOrganization')));
const EditOrganization = Loadable(lazy(() => import('../pages/dashboard/Organization/EditOrganization')));
